var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronStop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.280665 1.175C0.580665 0.875 1.08067 0.875 1.38067 1.175L6.18066 5.975L1.38066 10.775C1.08066 11.075 0.580664 11.075 0.280664 10.775C-0.019336 10.475 -0.019336 9.975 0.280664 9.675L3.98066 5.975L0.280665 2.275C-0.0193353 1.975 -0.0193352 1.475 0.280665 1.175Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.28084 10.9746C8.88084 10.9746 8.48084 10.6746 8.48084 10.1746L8.48084 1.67461C8.48084 1.27461 8.78084 0.87461 9.28084 0.87461C9.68084 0.87461 9.98084 1.17461 9.98084 1.67461L9.98084 10.1746C10.0808 10.5746 9.78084 10.9746 9.28084 10.9746Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronStop);
export default __webpack_public_path__ + "static/media/chevron-stop.08f815feac0940133ec36eed7cd75c10.svg";
export { ForwardRef as ReactComponent };